module.exports = __webpack_public_path__ + "img/hg.5e327fd5.png";